import client from '../client';
import endpoints from '../endpoints';

/* ── 서비스 (유저용) ── */

/** POST /api/partners/apply */
export const applyPartner = async (data) => {
  const res = await client.post(endpoints.partners.apply, data);
  return res.data;
};

/** GET /api/partners/me */
export const getPartnerMe = async (params = {}) => {
  const res = await client.get(endpoints.partners.me, { params });
  return res.data;
};

/* ── 관리자 ── */

/** GET /api/admin/partners */
export const getAdminPartners = async (params = {}) => {
  const res = await client.get(endpoints.admin.partners.list, { params });
  return res.data;
};

/** PUT /api/admin/partners/:id/status */
export const updateAdminPartnerStatus = async (id, data) => {
  const res = await client.put(endpoints.admin.partners.status(id), data);
  return res.data;
};
